module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays.5bf577a5.webp";